export enum SpacerSpacing {
  BOTTOM = 'bottom',
  TOP = 'top',
  FULL = 'full',
  NOSPACE = 'nospace'
}
